// extracted by mini-css-extract-plugin
export default {"header":"HeaderList_header__N7jbf","titleWrap":"HeaderList_titleWrap__Yb3y+","title":"HeaderList_title__nfYZL","backWrap":"HeaderList_backWrap__OefAf"};